import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexContainer } from '../../layout/FlexContainer';
export const ToggleInputRow = ({ togglePosition, toggleElement, labelElement, tooltipElement, }) => {
    const rowContentMap = {
        left: (_jsxs(_Fragment, { children: [_jsxs(FlexContainer, { verticalAlign: 'center', gap: '1', children: [toggleElement, labelElement] }), tooltipElement] })),
        right: (_jsxs(_Fragment, { children: [labelElement, _jsxs(FlexContainer, { gap: '1', children: [tooltipElement, toggleElement] })] })),
    };
    return (_jsx(FlexContainer, { direction: 'row', verticalAlign: 'center', gap: '1', horizontalAlign: 'spaceBetween', children: rowContentMap[togglePosition] }));
};
